import is from '@sindresorhus/is';
import noop from 'lodash/noop';
import { createContext, type FunctionComponent, type ReactNode, useCallback, useContext, useState } from 'react';

import { TilingEngine } from '~/ui/domain/tiling-engine/TilingEngine';

import { SkillsDetailsPanel } from '../../skills';

type OpenChatSkill = (skillId: string) => void;

const ChatSkillSidepanelContext = createContext<OpenChatSkill>(noop);

export const useOpenChatSkill = (): OpenChatSkill => useContext(ChatSkillSidepanelContext);

export const ChatSkillSidepanelProvider = ChatSkillSidepanelContext.Provider;

export const ChatSkillSidepanelHost: FunctionComponent<{ readonly children: ReactNode }> = ({ children }) => {
    const [skillId, setSkillId] = useState<string | null>(null);
    const closePanel = useCallback(() => setSkillId(null), []);

    return (
        <ChatSkillSidepanelContext.Provider value={setSkillId}>
            {children}
            {is.nonEmptyString(skillId) ? (
                <TilingEngine.Portal id="chat-skill-details" maxWidth="600px" minWidth="600px">
                    <SkillsDetailsPanel id={skillId} onClose={closePanel} onNavigate={setSkillId} />
                </TilingEngine.Portal>
            ) : null}
        </ChatSkillSidepanelContext.Provider>
    );
};
